import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { useComposerPlusIcon } from '#pplx/frontend/composer-sdk/components/ComposerPlusIcon.js';
import React from 'react';
import { useIntl } from 'react-intl';
export function PlusButton({ expanded = false, ...props }) {
    const { $t } = useIntl();
    const { icon: plusIcon, closeLabel } = useComposerPlusIcon(expanded);
    return (_jsx(Button, { ...props, rounded: true, icon: plusIcon, "aria-label": closeLabel ??
            $t({
                defaultMessage: 'Add files or tools',
                description: 'Aria label for the composer plus menu button',
                id: '8838a73168',
            }), size: "small", variant: "text", interactableVariant: "alt" }));
}
//# sourceMappingURL=PlusButton.js.map